import React from 'react';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';

import { SYMBOL_INITIAL } from './symbols';

class ActionButtonComponent extends React.Component {

  getFnValue(action, field) {
    const value = action[field];
    if (!(value instanceof Function)) {
      return value;
    }
    return value(action, field, this.props);
  }

  getAction(action, index) {
    return (
      <Button
        disabled={(!action.reset || this.props.data[SYMBOL_INITIAL]) && !!this.getFnValue(action, 'disabled')}
        size="xs"
        key={index}
        onClick={(event) => {
          if (action.onClick) {
            return action.onClick(event, action, this.props)
          }
          if (action.revert && this.props.data[SYMBOL_INITIAL]) {
            this.props.node.setData(this.props.data[SYMBOL_INITIAL]);
          } else if (action.revert && !this.props.data[SYMBOL_INITIAL]) {
            this.props.api.updateRowData({
              remove: [
                this.props.node.data
              ]
            });
          }
        }}
        style={{marginTop: 0, marginRight: 5 }}
      >
        {action.name}
      </Button>
    );
  }

  render() {
    const { value } = this.props;
    const actions = Array.isArray(value) ? value : [value];
    return (
      <React.Fragment>
        {
          actions
            .map((action, index) => action ? this.getAction(action, index) : <React.Fragment key={index} />)
        }
      </React.Fragment>
    );
  }

}

export const ActionShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  revert: PropTypes.bool
});

ActionButtonComponent.propTypes = {
  value: PropTypes.oneOfType([
    ActionShape.isRequired,
    PropTypes.arrayOf(
      ActionShape.isRequired
    ).isRequired
  ])
};

export default ActionButtonComponent;



// WEBPACK FOOTER //
// ./src/views/common/action-button.js